<template>
  <div v-scroll="onScroll" v-resize="onResize">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="adjustmentObj" ref="adjustmentRef" v-else>
      <template slot="title-actions">
        <template v-for="(button, index) in formReferences.end_buttons">
          <v-btn class="mx-1" :key="index" :loading="button.loading" :id="button.name" v-if="button.is_show" @click="button.click" :color="button.color" :disabled="button.disabled"
            :class="button.class || ''"> {{ button.label }} </v-btn>
        </template>
      </template>
      <template slot="extraDetails" class="mb-3">
        <v-row>
          <v-col cols="12" class="text-right pl-2 pr-2 pt-0 pb-0">
            <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-form ref="orderItems">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('message.warehouse.product') }}*
                    <v-progress-circular v-if="loadingProducts" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th>{{ $t('message.whOrder.minQty') }}</th>
                  <th>
                    {{ $t('message.stock.location') }}*
                    <v-progress-circular indeterminate v-if="loadingLocations" color="primary"></v-progress-circular>
                  </th>
                  <th>{{ $t('message.order.qty') }} (+/-)*</th>
                  <th v-if="adjustmentObj.status !== 'ordered' && adjustmentObj.status !== 'draft'">
                    {{ $t('message.order.batchNo') }}
                    <v-progress-circular v-if="loadingBatchNumber" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th v-if="adjustmentObj.status !== 'ordered' && adjustmentObj.status !== 'draft'">{{ $t('message.whOrder.recQty') }} (+/-)</th>
                  <th>{{ $t('message.common.comments') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in orderItems" :key="index" class="pt-4">
                  <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
                  <td width="25%">
                     <v-autocomplete v-model="element.productid" :items="element.products" item-text="productName" item-value="id" :rules="$_requiredValidation"
                      @keyup="$event.keyCode !== 13 && $event.keyCode !== 9 ? loadProducts(`searchInput${index}`, index, $event) : ''" autocomplete="off"
                      :ref="`searchInput${index}`" outlined dense
                      :loading="element.productLoader"
                      @click="toggleAllProducts(index, SHOW)"
                      @blur="toggleAllProducts(index, HIDE, element.productid)"
                      @change="getActiveProuct(index, element.productid)" :disabled="disableFields"
                     hide-details full-width :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                  </td>
                  <td width="5%">
                    <span>{{ element.minstock }}</span>
                  </td>
                  <td width="15%">
                    <template v-if="element.adjustorder">
                      <v-autocomplete autocomplete="off"
                        @keyup="$event.keyCode !== 13 ? loadLocation(`searchLocation${index}`, index, $event, element.productid) : ''"
                        :ref="`searchLocation${index}`"
                        @click="toggleLocation(index, SHOW)"
                        @focusout="toggleLocation(index, HIDE, element.adjustorder.locationid)"
                        :disabled="disableFields" v-model="element.adjustorder.locationid"
                        :rules="$_requiredValidation" :items="element.locations"
                        item-text="location_name" item-value="locationid"
                        :loading="element.locationLoading"
                        hide-details full-width outlined dense :placeholder="$t('message.order.searchLocation')"
                        @change="getBatchNumbersHandler(index, element.productid, element.adjustorder.locationid)">
                        <template v-slot:no-data>
                          <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                        </template>
                      </v-autocomplete>
                    </template>
                  </td>
                  <td width="10%">
                    <v-text-field v-model="element.qty" outlined dense :rules="element.qty ? $_norwegianNumberMinusValidation : $_requiredValidation"
                    :disabled="disableFields" :ref="`qty_${index}`"
                    @keyup="validateQtyIndex(index)" hide-details full-width :placeholder="$t('message.common.typeHere')" @change="autoSave"></v-text-field>
                  </td>
                  <td width="10%" v-if="adjustmentObj.status !== 'ordered' && adjustmentObj.status !== 'draft'">
                    <template v-if="element.isbatch">
                      <v-text-field class="mb-1" v-if="$formatter.replaceCommaWithDot(element.qty) > 0" outlined dense :disabled="adjustmentObj.status === 'received'"
                        v-model="element.adjustorder.batchnumber" hide-details :placeholder="$t('message.common.typeHere')"
                        :rules="$_requiredValidation"  @change="validateBatchQty(index)"></v-text-field>
                      <!-- Show batchnumbers to be selected -->
                      <v-autocomplete v-else autocomplete="off"
                        v-model="element.adjustorder.batchnumber" :disabled="adjustmentObj.status === 'received'"
                        :rules="$_requiredValidation" :items="element.batch_numbers" item-text="batchnumber_ref" item-value="batchnumber"
                        hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"  @change="validateBatchQty(index)"></v-autocomplete>
                    </template>
                  </td>
                  <td width="10%" v-if="adjustmentObj.status !== 'ordered' && adjustmentObj.status !== 'draft'">
                    <v-text-field  v-model="element.receivedqty" outlined dense hide-details full-width
                     @change="validatReceivedQtyIndex(index)" disabled></v-text-field>
                  </td>
                  <td width="15%">
                    <v-text-field  v-model="element.comments" outlined dense type="text" :disabled="adjustmentObj.status === 'received'" hide-details full-width :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <td width="15%">
                    <v-btn class="mx-2" text fab dark small color="primary" v-if="adjustmentObj.status !== 'received'"
                    @click="deleteProductRow(index, element.id)">
                      <v-icon dark>mdi-minus-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
        <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler" v-if="adjustmentObj.warehouseid && !this.disableFields">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn fab bottom right color="primary" small id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
    </form-data>
    <!-- Confirmation to set package itself or its content -->
    <v-dialog v-model="packageConfirmation.dialog" persistent width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.confirmation') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2">{{ $t('message.warehouse.addPackageOrContent') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="packageConfirmation.packLoading" @click="packageConfirmation.packageHandler">{{ $t('message.product.addPackage') }} </v-btn>
          <v-btn color="error" :loading="packageConfirmation.contentLoading" @click="packageConfirmation.contentHandler">{{ $t('message.warehouse.contents') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../../components/FormTemplate'
import CONSTANTS from '@/utils/warehouse.json'
import goTo from 'vuetify/lib/services/goto'
export default {
  data () {
    return {
      adjustmentObj: {
        id: this.$route.params.adjust_id,
        file: [],
        status: 'draft',
        priority: 'medium',
        datePicker: ''
      },
      fieldsLoading: false,
      disableFields: false,
      statusDisable: false,
      loading: false,
      orderItems: [],
      listOfProducts: [],
      loadingProducts: false,
      loadingBatchNumber: false,
      isAutoSave: false,
      showScrollToTop: false,
      showScrollToBottom: false,
      packageConfirmation: {
        dialog: false,
        packLoading: false,
        contentLoading: false
      },
      loadingLocations: false
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfWarehouse']),
    statusList () {
      if (!this.$route.params.adjust_id) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }]
      } else if (this.adjustmentObj.status !== CONSTANTS.RECEIVED) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }, {
          name: this.$t('message.common.inProgress'), id: CONSTANTS.INPROGRESS
        }, {
          name: this.$t('message.common.partiallyReceived'), id: CONSTANTS.PARTIALLYRECEIVED, disabled: true
        }]
      } else {
        return [{
          name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED, disabled: true
        }]
      }
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    formReferences () {
      return {
        title: this.$route.params.adjust_id ? `${this.$t('message.whOrder.updateAdjustmentOrder')} (${this.adjustmentObj.number || ''})` : this.$t('message.whOrder.addAdjustmentOrder'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg3 sm6 xs12',
          disabled: this.disableFields,
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.orderDate'),
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.$_priorityList,
          disabled: this.disableFields,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          disabled: this.$route.params.adjust_id ? true : false,
          click: (term) => null,
          term: 'warehouse',
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.statusList,
          term: '',
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          disabled: this.statusDisable,
          label: this.$t('message.customer.status'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          label: this.$t('message.common.comments'),
          disabled: this.disableFields,
          class: 'lg3 sm6',
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.adjust_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveWithoutAuto(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'action_handler_update',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveWithoutAuto(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.adjust_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.go(-1),
          label: this.$t('message.common.backToList'),
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          disabled: this.statusDisable,
          is_show: this.$route.params.adjust_id
        }],
        end_buttons: [{
          name: 'download',
          color: 'success',
          click: () => this.$parent.$parent.printOrder({ ...this.adjustmentObj, type_ref: 'adjustment' }),
          loading: false,
          label: this.$t('message.product.print'),
          class: 'text-right',
          is_show: this.$route.params.adjust_id
        }, {
          name: 'share',
          color: 'info',
          label: this.$t('message.common.send'),
          click: () => this.$parent.$parent.sendReport({ ...this.adjustmentObj, type_ref: 'adjustment' }),
          loading: false,
          class: 'text-right',
          is_show: this.$route.params.adjust_id
        }]
      }
    }
  },
  mounted () {
    this.adjustmentObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    if (this.adjustmentObj.id) {
      if (this.$route.query.autosave && this.$route.query.autosave === 'true') this.getSingleRecordHandler(true, true) // for loader - true, tosetFocus - true
      else this.getSingleRecordHandler(true, false)
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
      this.isAutoSave = false
    }
    // this.getProductHandler()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.ORDERITEMS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (!data.orderItemsAutoSave) this.getSingleRecordHandler()
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$store.commit('isChangesMade', false)
        this.$router.push('/w_h/order')
      }
    })
    // read supporting list items
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.adjustmentObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    // this.$store.dispatch('getWarehouseLocations')
    this.adjustmentObj.type = this.ADJUSTMENTORDER
  },
  watch: {
    'adjustmentObj.datePicker' (val) {
      if (val) {
        this.adjustmentObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'adjustmentObj.warehouseid' (val) {
      if (val) {
        this.orderItems = []
        this.addProductRowHandler()
      } else {
        this.clearLocationRefForWarehouse()
      }
    },
    'adjustmentObj.status' (val) {
      if (!val || val === CONSTANTS.DRAFT) {
        this.disableFields = false
        this.orderItems.map(x => {
          x.receivedqty = null
          return x
        })
      } else this.disableFields = true
      if (val === CONSTANTS.INPROGRESS) {
        this.orderItems.map(x => {
          x.receivedqty = x.qty
          return x
        })
      }
    }
  },
  methods: {
    autoSave () {
      if (this.orderItems.length >= 1) {
        let canSave = true
        this.orderItems.every((element) => {
          if (!element.productid && !element.qty && !element.locationid) {
            canSave = false
            return false
          } else return true
        })
        if (canSave) {
          this.saveUpdateHandler(this.SAVE, true)
        }
      }
    },
    saveWithoutAuto (type) {
      setTimeout(() => {
        if (!this.loading) this.saveUpdateHandler(type)
      }, 300)
    },
    clearLocationRefForWarehouse () {
      let productItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < productItems.length; i++) {
        let productItem = this.orderItems[i]
        productItem.adjustorder.locationid = null
        this.$set(this.orderItems, i, productItem)
      }
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        // let model = {
        //   'filter': `number contains '${searchText}' OR name contains  '${searchText}'`,
        //   'additionalfilters': [`isactive eq 1`],
        //   'skip': 0,
        //   'limit': 50,
        //   'order_by': {
        //     'field': 'number',
        //     'asc_or_desc': 'desc'
        //   }
        // }
        this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: true })
        this.$_executeApi('post', `products/search_products_num_desc?term=${searchText}`).then((response) => {
          this.orderItems[index].products = []
          if (response.data.length > 0) {
            response.data = response.data.filter(x => !x.notinventoryitem)
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.orderItems[index].products = response.data
          }
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: false })
        })
      }
    },
    addProductRowHandler () {
      this.orderItems.push({ products: [], locationid: 0, adjustorder: {} })
    },
    loadLocation (ref, index, event, productid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[ref][0].lazySearch
      if (searchText && productid) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
        this.$_executeApi('get', `/stocks/get_warehouse_locations_with_stock?product_id=${productid}&warehouse_id=${this.adjustmentObj.warehouseid}&search_term=${searchText}`)
          .then((result) => {
            let model = result.data
            // model = model.filter(x => x.on_stock)
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.on_stock})`
              return x
            })
            this.$set(this.orderItems, index, { ...this.orderItems[index], locations: model })
          }).finally(() => {
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
          })
      }
    },
    toggleLocation (index, action, locationid) {
      if (locationid) {
        let items = this.$formatter.cloneVariable(this.orderItems)
        if (action === this.HIDE && items[index] && items[index].adjustorder && items[index].locations) {
          let locations = items[index].locations.filter(x => x.locationid === locationid)
          items[index].locations = locations
        }
        if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
      }
    },
    getBatchNumbersHandler (index, productid, locationid) {
      return new Promise((resolve, reject) => {
        let getObj = this.$formatter.cloneVariable(this.orderItems[index])
        this.$_executeApi('get', `/warehouseorderitems/get_batchnumbers_by_location?product_id=${productid}&location_id=${locationid || 0}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.batchnumber_ref = ''
              x.batchnumber_ref = `${x.batchnumber} (${x.onstock})`
              return x
            })
            if (getObj) {
              if (!getObj.batch_numbers) getObj.batch_numbers = []
              getObj.batch_numbers = model
              this.$set(this.orderItems, index, getObj)
            }
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    validateBatchQty (index) {
      let currentItem = this.$formatter.cloneVariable(this.orderItems[index])
      currentItem.qty = currentItem.qty ? parseFloat(this.$formatter.replaceCommaWithDot(currentItem.qty)) : 0
      if (currentItem.qty < 0) {
        let selectedBatchNumber = currentItem.batch_numbers.find(x => x.batchnumber === currentItem.adjustorder.batchnumber)
        if (selectedBatchNumber) {
          const onStock = parseFloat(this.$formatter.replaceCommaWithDot(selectedBatchNumber.onstock))
          if (onStock < Math.abs(currentItem.qty)) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
            currentItem.qty = currentItem.qty ? this.$formatter.replaceDotWithComma(currentItem.qty) : 0
            this.$nextTick(() => {
              this.$set(this.orderItems[index].adjustorder, 'batchnumber', null)
            })
          }
        }
      }
    },
    getSingleRecordHandler (showLoader, setFocusOnQty) {
      this.fieldsLoading = showLoader
      this.$_getSingleRecordHandler(`${this.WH_ORDER}/${this.adjustmentObj.id}`)
        .then((result) => {
          let transformDate = { date: { list: ['orderdate'], from: 'DD-MM-YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
          let model = this.$_formatModel(result.data, transformDate)
          this.adjustmentObj = model
          document.title = `Lager/Ordre/${model ? model.number : ''}`
          const getType = this.$_orderType.find(x => x.value === this.adjustmentObj.type)
          const type = getType ? getType.text : this.adjustmentObj.type
          this.adjustmentObj = Object.assign({ ...this.adjustmentObj }, { type })
          if (this.adjustmentObj.status === CONSTANTS.RECEIVED) this.statusDisable = true
          this.getOrderItemsHandler(this.adjustmentObj.id, setFocusOnQty)
        })
    },
    getOrderItemsHandler (id, setFocusOnQty) {
      let url = `warehouseorderitems/get_by_order/${id}`
      this.loadingProducts = true
      this.loadingBatchNumber = true
      this.$_executeApi('get', url)
        .then(async (response) => {
          let data = response.data
          let transformNumber = { number: { list: ['qty', 'onstock', 'minstock', 'receivedqty'], format: 'replaceDotWithComma' }, adjustment: {} }
          data = this.$_formatListModel(data, transformNumber)
          let result = []
          for (let i = 0; i < data.length; i++) {
            data[i].products = []
            data[i].locations = []
            data[i].products.push({
              id: data[i].productid,
              productName: data[i].productnumber ? `${data[i].productnumber} - ${data[i].productname}` : data[i].productname
            })
            data[i].locations.push({
              locationid: data[i].adjustorder.locationid,
              on_stock: data[i].adjustorder.availablestockqty,
              location_name: `${data[i].adjustorder.locationname} (${this.$formatter.replaceDotWithComma(data[i].adjustorder.availablestockqty) || '0, 00'})`
            })
            if (!data[i].adjustorder.locationid) {
              data[i].locations = await this.getStockHandler(data[i].productid)
            }
            const qty = this.$formatter.replaceCommaWithDot(data[i].qty)
            if (data[i].isbatch && +qty < 0 && this.adjustmentObj.status !== 'received') {
              data[i].batch_numbers = await this.getBatchNumbersHandler(i, data[i].productid, data[i].adjustorder.locationid)
            } else {
              var batchOnStock = ''
              if (data[i].adjustorder && data[i].adjustorder.stockqtyperbatchnumber) {
                batchOnStock = this.$formatter.replaceDotWithComma(data[i].adjustorder.stockqtyperbatchnumber)
              }
              data[i].batch_numbers = []
              data[i].batch_numbers.push({
                batchnumber: data[i].adjustorder.batchnumber,
                batchnumber_ref: `${data[i].adjustorder.batchnumber} (${batchOnStock})`
              })
            }
            result.push(data[i])
          }
          this.orderItems = result
          if (setFocusOnQty) {
            setTimeout(() => {
              this.$refs[`qty_${this.orderItems.length - 1}`][0].focus()
            }, 100)
          }
          this.loadingProducts = false
          this.loadingBatchNumber = false
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type, autoSave) {
      if (autoSave || this.$refs.adjustmentRef.$refs.validateForm.validate()) {
        if (autoSave ? this.$refs.orderItems && this.$refs.orderItems.validate() : true) {
          this.loading = true
          let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
          let model = this.$formatter.cloneVariable(this.adjustmentObj)
          model = this.$_formatModel(model, transformData)
          let url = this.WH_ORDER
          model.type = CONSTANTS.ADJUSTMENT
          this.$_saveUpdateHandler(url, model, autoSave)
            .then((response) => {
              this.adjustmentObj.id = response.id
              this.adjustmentObj.status = response.status
              this.$store.commit('isChangesMade', false)
              this.saveOrderItemsHandler(response.id, type, autoSave)
            })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      // if (this.$refs.adjustmentRef.$refs.validateForm.validate() && this.$refs.orderItems.validate()) {
      //   let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
      //   let model = this.$formatter.cloneVariable(this.adjustmentObj)
      //   model = this.$_formatModel(model, transformData)
      //   let url = this.WH_ORDER
      //   model.type = CONSTANTS.ADJUSTMENT
      //   this.$_saveUpdateHandler(url, model)
      //     .then((response) => {
      //       this.$store.commit('isChangesMade', false)
      //       this.saveOrderItemsHandler(response.id, type)
      //     })
      // } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveOrderItemsHandler (id, type, autoSave) {
      if (this.$refs.orderItems && this.$refs.orderItems.validate()) {
        let transformData = { number: { list: ['qty', 'onstock', 'receivedqty'], format: 'replaceCommaWithDot' } }
        let model = this.$formatter.cloneVariable(this.orderItems)
        model = this.$_formatListModel(model, transformData)
        let orderItemsJSON = { 'items': this.$formatter.cloneVariable(model) }
        let url = `/warehouseorderitems/bulk_save/${id}`
        this.$_executeApi('post', url, orderItemsJSON).then((response) => {
          if (autoSave) {
            this.orderItems.forEach((element, index) => {
              element.id = response.data[index].id
              element.orderid = id
            })
          }
          this.adjustmentObj.id = id
          // if (this.$route.params.adjust_id && type !== this.UPDATE_CLOSE && !autoSave)
          this.getSingleRecordHandler(false)
          if (!autoSave && type === this.SAVE && id) this.$router.push(`/w_h/order/adjustmentorder/actions/${id}`).catch((err) => console.log(err))
          else if (!autoSave && type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
          else if (!this.$route.params.adjust_id) this.$router.push(`/w_h/order/adjustmentorder/actions/${id}?autosave=true`)
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    async getActiveProuct (index, productid) {
      let getProduct = this.orderItems[index].products
      if (getProduct) {
        let stockObjs = []
        const result = getProduct.find(x => x.id === productid)
        const getObj = this.$formatter.cloneVariable(this.orderItems[index])
        if (result && result.ispackage) {
          this.packageConfirmation = {
            dialog: true,
            packLoading: false,
            contentLoading: false,
            packageHandler: async () => {
              this.packageConfirmation.packLoading = true
              stockObjs = await this.getStockHandler(productid)
              getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
              getObj.available = this.$formatter.replaceDotWithComma(result.available || 0)
              getObj.isbatch = result.batchrequired || result.productworkflow_is_generate_win
              if (stockObjs && stockObjs.length === 1) {
                if (!getObj.adjustorder) getObj.adjustorder = {}
                if (!getObj.adjustorder.locationid) {
                  getObj.adjustorder.locationid = stockObjs[0].locationid
                }
              }
              getObj.locations = stockObjs
              this.$set(this.orderItems, index, getObj)
              this.packageConfirmation.dialog = false
              this.packageConfirmation.packLoading = false
              this.autoSave()
            },
            contentHandler: async () => {
              this.loadingProducts = true
              this.packageConfirmation.contentLoading = false
              await this.getProductsByPackage(productid, index)
              this.packageConfirmation.dialog = false
              this.packageConfirmation.contentLoading = false
              this.autoSave()
            }
          }
        } else if (result) {
          stockObjs = await this.getStockHandler(productid)
          if (stockObjs && stockObjs.length === 1) {
            if (!getObj.adjustorder) getObj.adjustorder = {}
            if (!getObj.adjustorder.locationid) {
              getObj.adjustorder.locationid = stockObjs[0].locationid
            }
          }
          getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
          getObj.available = this.$formatter.replaceDotWithComma(result.available || 0)
          getObj.isbatch = result.batchrequired || result.productworkflow_is_generate_win
          getObj.locations = stockObjs
          this.$set(this.orderItems, index, getObj)
          this.autoSave()
        }
      }
    },
    async getProductsByPackage (id, index) {
      let query = {
        select: [],
        expand: [{
          'model': 'Product',
          'on_field': 'id',
          'on_parent_field': 'productid'
        }],
        filter: `packageid eq '${id}'`
      }
      this.$_executeApi('post', 'productpackages/query', query)
        .then(async (response) => {
          let getAllProducts = []
          let list = response.data
          for (let i = 0; i < list.length; i++) {
            let products = [{ id: list[i].product_id, productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name }]
            let locations = await this.getStockHandler(list[i].product_id) || []
            getAllProducts.push({ products,
              productid: list[i].product_id,
              minstock: list[i].product_minstock ? this.$formatter.replaceDotWithComma(list[i].product_minstock) : 0,
              adjustorder: { locationid: 0 },
              locations: locations,
              isbatch: list[i].product_batchrequired,
              productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.orderItems = getExistingItems
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    validatReceivedQtyIndex (index) {
      let getObj = this.$formatter.cloneVariable(this.orderItems[index])
      let getQty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.qty || 0))
      let getReceivedQty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.receivedqty || 0))
      if (getQty !== getReceivedQty) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.qtySame') })
        this.$set(this.orderItems, index, { ...getObj, receivedqty: '' })
      }
    },
    // checkQtyOfBatchNumber (index, batchNumber) {
    //   let getObj = this.$formatter.cloneVariable(this.orderItems[index])
    //   if (getObj) {
    //     let getBatch = getObj.adjustorder.batchnumber
    //     let stockObj = getObj.batch_numbers.find(x => x.batchnumber === getBatch)
    //     if (stockObj) {
    //       let stockValue = -+parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
    //       let qty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty || 0))
    //       if (qty < stockValue) {
    //         setTimeout(() => {
    //           getObj.adjustorder.batchnumber = ''
    //           this.$set(this.orderItems, index, getObj)
    //         })
    //         this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
    //       }
    //     }
    //   }
    // },
    // checkBatchNumber (index, batchNumber) {
    //   this.loadingBatchNumber = true
    //   let getObj = this.$formatter.cloneVariable(this.orderItems[index])
    //   this.$_executeApi('get', `/warehouseorderitems/is_batchnumber_exists?batchNumber=${batchNumber}&productId=${getObj.productid}&locationId=${getObj.adjustorder.locationid}`)
    //     .then(response => {
    //       if (response) {
    //         if (response.data) {
    //           setTimeout(() => {
    //             getObj.adjustorder.batchnumber = ''
    //             this.$set(this.orderItems, index, getObj)
    //           })
    //           this.$root.$emit('snackbar', {
    //             snackbar: true,
    //             color: 'error',
    //             text: this.$t('message.common.batchExists')
    //           })
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.loadingBatchNumber = false
    //     })
    // },
    deleteHandler () {
      let ids = [this.adjustmentObj.id]
      let data = { module: this.WH_ORDER, ids }
      let payload = { ids: data.ids, url: `${this.WH_ORDER}/delete_multiple`, module: this.WH_ORDER }
      this.$store.commit('showDeleteDialog', payload)
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.adjustmentRef.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    validateQtyIndex (index) {
      let getObj = this.$formatter.cloneVariable(this.orderItems[index])
      if (getObj) {
        let getLocationId = getObj.adjustorder.locationid
        let stockObj = getObj.locations.find(x => x.locationid === getLocationId)
        if (stockObj) {
          if (stockObj.on_stock === undefined || stockObj.on_stock === null) stockObj.on_stock = 0
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.on_stock) || 0)
          let qty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty || 0))
          if (qty < 0) {
            const wholeValue = -qty
            if (wholeValue > stockValue) {
              getObj.qty = ''
              this.$set(this.orderItems, index, getObj)
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
            }
          }
        } else this.autoSave()
      }
      // this.orderItems[index].receivedqty = this.orderItems[index].qty
    },
    getStockHandler (productid) {
      return new Promise((resolve, reject) => {
        this.loadingLocations = true
        this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.adjustmentObj.warehouseid || 0}`)
          .then((result) => {
            let model = result.data
            model = model.filter(x => x.on_stock > 0)
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.on_stock})`
              x.id = x.locationid
              x.name = x.location_name
              return x
            })
            this.loadingLocations = false
            resolve(model)
          })
          .catch((err) => {
            reject(err)
            this.loadingLocations = false
          })
      })
    },
    deleteProductRow (index, id) {
      if (this.orderItems[index].id) {
        let payload = { ids: [id], url: `${this.ORDERITEMS}/delete_multiple`, module: this.ORDERITEMS, orderItemsAutoSave: this.$route.params.adjust_id || null }
        this.$store.commit('showDeleteDialog', payload)
      } else this.orderItems.splice(index, 1)
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index].products) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      this.$set(this.orderItems, index, items[index])
    },
    setDefaultValues (data) {
      let { list, prop } = data
      if (list && list.length === 1) {
        let model = Object.assign({ ...this.adjustmentObj }, { [prop]: list[0].id })
        this.adjustmentObj = model
      }
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
